export type DifficultyTier = 'difficult' | 'recommended' | 'easier'

export interface TeamSizeBounds {
  teamSizeMin: number
  teamSizeMax: number
  teamSizeTarget: number
}

export interface TeamSizeTier {
  id: DifficultyTier
  label: string
  sizes: number[]
  rangeLabel: string
}

export function formatSizeRange(sizes: number[]): string {
  if (sizes.length === 0) return ''
  if (sizes.length === 1) return String(sizes[0])
  return `${sizes[0]}–${sizes[sizes.length - 1]}`
}

export function getTeamSizeTiers(bounds: TeamSizeBounds): TeamSizeTier[] {
  const { teamSizeMin, teamSizeMax, teamSizeTarget } = bounds
  const tiers: TeamSizeTier[] = []

  const harder: number[] = []
  for (let size = teamSizeMin; size < teamSizeTarget; size++) harder.push(size)

  const recommended = [teamSizeTarget]

  const easier: number[] = []
  for (let size = teamSizeTarget + 1; size <= teamSizeMax; size++) easier.push(size)

  if (harder.length > 0) {
    tiers.push({
      id: 'difficult',
      label: 'Difficult',
      sizes: harder,
      rangeLabel: formatSizeRange(harder),
    })
  }

  tiers.push({
    id: 'recommended',
    label: 'Recommended',
    sizes: recommended,
    rangeLabel: formatSizeRange(recommended),
  })

  if (easier.length > 0) {
    tiers.push({
      id: 'easier',
      label: 'Easier',
      sizes: easier,
      rangeLabel: formatSizeRange(easier),
    })
  }

  return tiers
}

export function getTierForSize(size: number, bounds: TeamSizeBounds): DifficultyTier {
  if (size < bounds.teamSizeTarget) return 'difficult'
  if (size > bounds.teamSizeTarget) return 'easier'
  return 'recommended'
}
